import { useCan, useSelectedDealer } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { sortQuestionsByTitle } from "modules/ChecklistsDashboard/util";
import { ApiInstance } from "utils/Api";

export const useDealerQuestionsQuery = () => {
  const { selectedDealer } = useSelectedDealer();
  const canListQuestions = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.Questions);

  return useTypedQuery({
    queryKey: ChecklistsDashboardQueryKeys.dealerQuestions(selectedDealer?.id),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.questions ?? [],
    select: sortQuestionsByTitle,
    enabled: canListQuestions && !!selectedDealer?.id
  });
};
